import { render, staticRenderFns } from "./PressVisa.vue?vue&type=template&id=470413c2&scoped=true&"
import script from "./PressVisa.vue?vue&type=script&lang=js&"
export * from "./PressVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470413c2",
  null
  
)

export default component.exports